import React, {useState, useEffect} from 'react'
import { Typography , Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from '../api/axios'
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import EditTrainingDialog from './EditTrainingDialog';
import Link from '@mui/material/Link';

const useStyles = makeStyles((theme) => ({
	wrapper: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto",
        marginTop: '150px'
	},
    marginTop: {
        marginTop: '10px;'
    },
    paddingTopBottom: {
        paddingTop: '20px;',
        paddingBottom: '20px;'
    },
    searchIcon: {
		paddingTop: 5,
	},
	searchInput: {
		paddingLeft: 10,
		paddingTop: 5,
	},
    searchContainer: {
        border: "solid 1px black",
        borderRadius: "5px",
        marginBottom: "15px",
        minHeight: "56px"
    }
})); 

const ListTrainings = ({trainings, isAuth, fetchTrainings, getToken, institution, subject, start}) => {
    const classes = useStyles();

    const [openDeleteTraining, setOpenDeleteTraining] = useState(null);

    const [openEditTraining, setOpenEditTraining] = useState(false);
    const [editExistingTraining, setEditExistingTraining] = useState({ id: "", title:"", type: "", subject: "", network: "", institution: "", duration:"", ecpoints:0, start:0, contact: "", link:"", cost: "", note: ""});

    const [searchTerm, setSearchTerm] = useState("");

    const [subjectValue, setSubjectValue] = useState("");
    const [institutionValue, setInstitutionValue] = useState("");
    const [startValue, setStartValue] = useState("");

    const toSortableNumber = (str) => {

        var thenum = str.replace( /^\D+/g, '');

        thenum = thenum.split('/')[0]

        //console.log(thenum)

        if(!thenum){
            return 1000;
        }

        thenum = parseInt(thenum);

        if(str.indexOf('WS') > -1){
            return thenum + 0.5; 
        }
        return thenum;
    }

    const sortedStart = start.sort(function(a, b){

            let A = toSortableNumber(a);
            let B = toSortableNumber(b);

            if(A > B){
                return -1;
            } 
            if(A < B){
                return 1;
            }
            return 0;
    });

    const deleteTraining = () => {

        const options = {
            url: `/trainings/delete-training/${openDeleteTraining}`,
            method: 'delete',
            headers: getToken
        };
        
        return axios(options)
            .then((res) => {
                fetchTrainings();
            })
        .catch((error) => { console.log(error); });
    }

    const changeExistingTraining = (training) => {

        const options = {
            url: `/trainings/edit-training/${training.id}`,
            data: {
                title: training.title, 
                type: training.type, 
                subject: training.subject, 
                network: training.network, 
                institution: training.institution, 
                duration: training.duration, 
                ecpoints: training.ecpoints, 
                start: training.start, 
                contact: training.contact, 
                link: training.link, 
                cost: training.cost, 
                note: training.note
            },
            method: 'patch',
            headers: getToken
        };
        
        return axios(options)
            .then((res) => {
                fetchTrainings();
            })
        .catch((error) => { console.log(error); });
    }

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    }

    const filtered = trainings.filter((training) =>{
        let isVisible = true;

        if( isVisible && subjectValue){
            isVisible = training.subject !== null &&  training.subject.toLowerCase().includes(subjectValue.toLowerCase())
        }

        if( isVisible && institutionValue){
            isVisible = training.institution !== null &&  training.institution.toLowerCase().includes(institutionValue.toLowerCase())
        }

        if( isVisible && startValue){
            isVisible = training.start !== null &&  training.start.toLowerCase().includes(startValue.toLowerCase())
        }
        
        if( isVisible && searchTerm ){
          isVisible = training.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          ( training.type !== null &&  training.type.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.subject !== null &&  training.subject.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.network !== null &&  training.network.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.institution !== null &&  training.institution.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.duration !== null &&  training.duration.toString().toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.ecpoints !== null &&  training.ecpoints.toString().toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.start !== null &&  training.start.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.contact !== null &&  training.contact.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.link !== null &&  training.link.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.cost !== null &&  training.cost.toLowerCase().includes(searchTerm.toLowerCase()) ) ||
          ( training.note !== null &&  training.note.toLowerCase().includes(searchTerm.toLowerCase()) )
        }
        return isVisible;
      }
    )

    return (
        <>
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <Grid container className={classes.searchContainer} alignItems="center">
                            <Grid item  xs={11}>
                                <InputBase
                                    placeholder="Suchen"
                                    className={classes.searchInput}
                                    onChange={handleSearch}
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={1} className={classes.searchIcon}>
                                <SearchIcon fontSize="small" color="primary"/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{ minWidth: 200, width: "100%"}} >
                            <InputLabel id="subject-select-label">Thema</InputLabel>
                            <Select
                                labelId="subject-select-label"
                                id="subject-select"
                                value={subjectValue}
                                label="Thema"
                                onChange={(e) => {
                                    setSubjectValue(e.target.value);
                                }}
                                fullWidth
                            >
                            <MenuItem
                                key={0}
                                value={''}
                                >
                                Alle anzeigen
                            </MenuItem>
                            {subject.map((item, index) => (
                                <MenuItem
                                key={index}
                                value={item}
                                >
                                {item}
                                </MenuItem>
                            ))}
                                
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{  minWidth: 200, width: "100%" }} >
                            <InputLabel id="institution-select-label">Institution</InputLabel>
                            <Select
                                labelId="institution-select-label"
                                id="institution-select"
                                value={institutionValue}
                                label="Institution"
                                onChange={(e) => {
                                    setInstitutionValue(e.target.value);
                                }}
                                fullWidth
                            >
                            <MenuItem
                                key={0}
                                value={''}
                                >
                                Alle anzeigen
                            </MenuItem>
                            {institution.map((item, index) => (
                                <MenuItem
                                key={index}
                                value={item}
                                >
                                {item}
                                </MenuItem>
                            ))}
                                
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl sx={{  minWidth: 200, width: "100%"}} >
                            <InputLabel id="start-select-label">Beginn</InputLabel>
                            <Select
                                labelId="start-select-label"
                                id="start-select"
                                value={startValue}
                                label="Beginn"
                                onChange={(e) => {
                                    setStartValue(e.target.value);
                                }}
                                fullWidth
                            >
                            <MenuItem
                                key={0}
                                value={''}
                                >
                                Alle anzeigen
                            </MenuItem>
                            {sortedStart.map((item, index) => (
                                <MenuItem
                                key={index}
                                value={item}
                                >
                                {item}
                                </MenuItem>
                            ))}
                                
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </>
        { filtered.map((training, index) => (
            <Accordion key={training.id} className={classes.marginTop}>
                <AccordionSummary >
                    <Grid container spacing={2} >
                        {isAuth ? 
                        <>
                            <Grid item xs={12} md={8}>   
                                <Typography>
                                    {training.title}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={2} >   
                                <Button variant="outlined" onClick={() => {
                                    setOpenEditTraining(true);
                                    setEditExistingTraining({
                                        id: training.id, 
                                        title: training.title,
                                        type: training.type,
                                        subject: training.subject,
                                        network: training.network,
                                        institution: training.institution,
                                        duration: training.duration,
                                        ecpoints: training.ecpoints,
                                        start: training.start,
                                        contact: training.contact,
                                        link: training.link,
                                        cost: training.cost,
                                        note: training.note
                                    })
                                }} startIcon={<EditIcon />}>
                                    Bearbeiten
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={2} >   
                                <Button 
                                    onClick={() => {setOpenDeleteTraining(training.id)}}
                                    variant="outlined"  
                                    startIcon={<DeleteForeverIcon />} 
                                >
                                    Löschen
                                </Button>
                            </Grid>
                        </>
                        : 
                            <Grid item xs={12} >   
                                <Typography>
                                    {training.title}
                                </Typography>
                            </Grid>
                        }
                        { training.type ?
                            <Grid item xs={6} md={4}>
                                <Typography >
                                    Typ:
                                </Typography>
                                <Typography >
                                    {training.type}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { training.subject ?
                            <Grid item xs={6} md={4} >
                                <Typography >
                                    Thema:
                                </Typography>
                                <Typography >
                                    {training.subject}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { training.institution ?
                            <Grid item xs={6} md={4} >
                                <Typography >
                                    Institution:
                                </Typography>
                                <Typography >
                                    {training.institution}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                    </Grid>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <Grid container spacing={2} >
                        { training.network ?
                            <Grid item xs={12} >   
                                <Typography >
                                    Verbund: {training.network}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { training.duration ?
                            <Grid item xs={12} >
                                <Typography >
                                    Dauer: {training.duration} Semester
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { training.ecpoints ?
                            <Grid item xs={12} >
                                <Typography >
                                    Umfang in EC: {training.ecpoints}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { training.start ?
                            <Grid item xs={12} >
                                <Typography >
                                    Beginn: {training.start}
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { training.contact ?
                            <Grid item xs={12} >            
                                <Typography >
                                    Kontakt: <Link href={"mailto:" + training.contact}>{training.contact}</Link> 
                                </Typography>
                            </Grid>
                            :
                            ""
                        }
                        { training.cost ?
                             <Grid item xs={12} >
                                <Typography >
                                    Kosten:
                                </Typography>
                                <Typography >
                                    {training.cost}
                                </Typography> 
                            </Grid>
                            :
                            ""
                        }
                        { training.note ?
                             <Grid item xs={12} >
                                <Typography >
                                    Anmerkung:
                                </Typography>
                                <Typography >
                                    {training.note}
                                </Typography> 
                            </Grid>
                            :
                            ""
                        }
                        { training.link ?
                            <Grid item xs={12} >

                                <Button variant="outlined"
                                    href={training.link}
                                    target="_blank"
                                >
                                    Detailinformationen
                                </Button>
                                
                            </Grid>
                            :
                            ""
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>
        ))}
        <Dialog
            open={ openDeleteTraining !== null }
            onClose={() => {setOpenDeleteTraining(null)}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Weiterbildung löschen"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                Sind Sie sicher, dass Sie die Weiterbildung löschen möchten?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={() => {
                setOpenDeleteTraining(null);
                deleteTraining();
            }
            }>löschen</Button>
            </DialogActions>
        </Dialog>
        <EditTrainingDialog
            isDialogOpen={openEditTraining}
            setIsDialogOpen={setOpenEditTraining}
            editTraining={editExistingTraining}
            setEditTraining={setEditExistingTraining}
            saveCallback={changeExistingTraining}
            autoCompletes={{institutions: institution, subjects: subject}}
        />  
        </>
    );
}

export default ListTrainings;